module.exports = {
	"datepicker": {
		"toggleCalendar": "Kalender anzeigen"
	},
	"calendar": {
		"today": "Heute"
	},
	"dateinput": {
		"today": "Heute",
		"increment": "Vor",
		"decrement": "Zurück"
	},
	"datetimepicker": {
		"date": "Datum",
		"time": "Uhrzeit",
		"cancel": "Abbrechen",
		"set": "Auswählen"
	},
	"timepicker": {
		"set": "Auswählen",
		"cancel": "Abbrechen",
		"now": "Heute",
		"selectNow": "Heute auswählen",
		"toggleTimeSelector": "Uhrzeit-Auswahl anzeigen",
		"toggleClock": "Uhrzeit anzeigen"
	},
	"daterangepicker": {
		"swapStartEnd": "Start- und Enddatum tauschen",
		"start": "Start",
		"end": "Ende"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/messages.json
// module id = 6799
// module chunks = 0